import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import useQueryFilters from './useQueryFilters';
import useQueryFiltersTier3 from './useQueryFiltersTier3';
import useFilterData from './useFilterLSData';
import useConfigFilters from './useConfigFilters';

const useFilterResults = (remoteConfig: any) => {
  const isTier3page = remoteConfig?.isTier3page;

  const Tier3QueryParams = useQueryFiltersTier3();
  const parsedParamsTier3 =
    isTier3page && remoteConfig?.isUrlParamsDynamic ? Tier3QueryParams : null;

  const parsedParams = useQueryFilters();

  const parsedConfig = useConfigFilters(remoteConfig);

  const setParamsToLS = useCallback(() => {
    localStorage.setItem('selectedFilters-v4', JSON.stringify(parsedParams));
  }, [parsedParams]);

  if (!isTier3page) setParamsToLS();

  const parsedFilters = useFilterData();

  return {
    parsedFilters,
    parsedConfig,
    parsedParams: isTier3page ? parsedParamsTier3 : parsedParams,
  };
};

export default useFilterResults;
